var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.appStyle),attrs:{"id":"app"}},[_c('login-modal'),_c('layout',[_c('router-view')],1),_c('SystemInfo'),(_vm.isLoading)?_c('div',{staticClass:"loading"},[_c('div',[_c('LoadingBox',{attrs:{"hasBorder":false}})],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }